export default __webpack_public_path__ + "static/media/404.93415b2b.svg";